import { logger } from '../../../utils/logger'
import { IAuthenticationState, IAuthenticationActions } from './authentication.slice.interface'
import { createSlice } from '../zustandHelpers'
import { COMPONENTS_ROLE_ACCESS } from '../../../constants/user.constants'
import { USER_ROLE } from '../../../domain/enums/user.enums'

export const authenticationSlice = createSlice<IAuthenticationState, IAuthenticationActions>(
  (set) => ({
    loginRequest: {
      scopes: [],
    },
    user: {},
    isAuthenticated: false,
    error: undefined,
    loading: true,

    setLoginRequest: (loginRequest) => {
      set({
        loginRequest,
      })
    },
    setUserAuthentication: async (user) => {
      try {
        set({
          user: {
            name: user.user?.prenom,
            locale: 'fr',
            email: user.mail_user,
            familyName: user.user?.nom,
            givenName: user.user?.prenom,
            role: user.role.label,
            access: {
              dashboardProductionStat: COMPONENTS_ROLE_ACCESS.DASHBOARD_STATISTIC_PRODUCTION_COMPONENT.includes(
                user.role.label as USER_ROLE
              ),
              dashboardCaStat: COMPONENTS_ROLE_ACCESS.DASHBOARD_STATISTIC_CA_COMPONENT.includes(
                user.role.label as USER_ROLE
              ),
              dashboardGraph: COMPONENTS_ROLE_ACCESS.DASHBOARD_GRAPH_COMPONENT.includes(
                user.role.label as USER_ROLE
              ),
              dashboardDocumentList: COMPONENTS_ROLE_ACCESS.DASHBOARD_DOCUMENT_LIST_COMPONENT.includes(
                user.role.label as USER_ROLE
              ),
              documentPage: COMPONENTS_ROLE_ACCESS.DOCUMENTS_PAGE.includes(
                user.role.label as USER_ROLE
              ),
              downloadPage: COMPONENTS_ROLE_ACCESS.DOWNLOADS_PAGE.includes(
                user.role.label as USER_ROLE
              ),
              apiDocPage: COMPONENTS_ROLE_ACCESS.API_DOCUMENTATION_PAGE.includes(
                user.role.label as USER_ROLE
              ),
            },
          },
          isAuthenticated: true,
          error: undefined,
        })
      } catch (error) {
        logger.error(`error : ${error}`)

        set({
          user: {},
          isAuthenticated: false,
          error,
        })
      }
    },
  })
)
